import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.AddDocumentToVertaforePolicy.IRequest;
type Response = Api.Core.Contract.AddDocumentToVertaforePolicy.IResponse;
type Headers = Api.Core.Contract.AddDocumentToVertaforePolicy.IHeaders;
const url = '/api/Sales/Contract/AddDocumentToVertaforePolicy/:contractId';
export default async function contractAddDocumentToVertaforePolicyApi(params: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
